// src/context/LanguageContext.js
import React, { createContext, useState, useEffect } from "react";

export const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  // ✅ Load language from localStorage (if exists) or default to EN
  const [lang, setLang] = useState(() => {
    if (typeof window !== "undefined") {
      const stored = localStorage.getItem("esill-lang");
      if (stored === "EN" || stored === "AR") return stored;
    }
    return "EN";
  });

  const toggleLanguage = () => {
    setLang((prev) => (prev === "EN" ? "AR" : "EN"));
  };

  // APPLY RTL / LTR + HTML lang attribute + persist to localStorage
  useEffect(() => {
    if (lang === "AR") {
      document.documentElement.dir = "rtl";
      document.documentElement.lang = "ar";
    } else {
      document.documentElement.dir = "ltr";
      document.documentElement.lang = "en";
    }

    if (typeof window !== "undefined") {
      localStorage.setItem("esill-lang", lang);
    }
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
}
